import './style.css'
import { Game, type GameTestBridge } from './game/Game'

declare global {
  interface Window {
    __IRON_VEIL__?: GameTestBridge
  }
}

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas')
const hudRoot = document.querySelector<HTMLElement>('#hud-root')
const testMode =
  import.meta.env.MODE === 'e2e' &&
  new URLSearchParams(window.location.search).get('testMode') === '1'

if (!canvas || !hudRoot) {
  throw new Error('Game mount points are missing from index.html')
}

try {
  const game = new Game(canvas, hudRoot)
  window.__IRON_VEIL__ = {
    ready: true,
    start: () => game.start(),
    snapshot: () => game.snapshot(),
    ...(testMode
      ? {
          defeatActiveWaveForTest: (armorFraction?: number) => game.defeatActiveWaveForTest(armorFraction),
          setSpatialStateForTest: (state) => game.setSpatialStateForTest(state),
          measureFxBudgetsForTest: () => game.measureFxBudgetsForTest(),
          measureRenderCostForTest: (frames?: number) => game.measureRenderCostForTest(frames),
          damagePlayerForTest: (damage: number, impact?: number) => game.damagePlayerForTest(damage, impact),
          overloadTargetForTest: () => game.overloadTargetForTest(),
          freezeFxForTest: (frozen: boolean) => game.freezeFxForTest(frozen),
          armCaptureTrapForTest: (kind, weapon) => game.armCaptureTrapForTest(kind, weapon),
        }
      : {}),
  }
} catch (error) {
  const message = error instanceof Error ? error.message : String(error)
  document.body.innerHTML = `
    <main class="fatal-error" role="alert">
      <p>IRON VEIL // BOOT FAILURE</p>
      <h1>WebGL2を初期化できませんでした</h1>
      <pre></pre>
      <small>ブラウザのハードウェアアクセラレーションを有効にして再読み込みしてください。</small>
    </main>
  `
  const pre = document.querySelector('pre')
  if (pre) pre.textContent = message
  throw error
}
